import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';

import {
  DownloadTransactionReportStackRoutes,
  DownloadTransactionReportStackScreenProps
} from '@/features/account-management/screens/download-transaction-report/type';
import { DownloadCardAccountTransactionReportWebScreen } from '@/features/account-management/screens/download-transaction-report/DownloadCardAccountTransactionReportWeb.screen';
import { DownloadCardAccountTransactionReportNativeScreen } from '@/features/account-management/screens/download-transaction-report/DownloadCardAccountTransactionReportNative.screen';

export const DownloadCardAccountTransactionReport: React.FC<
  DownloadTransactionReportStackScreenProps<DownloadTransactionReportStackRoutes.DownloadCardAccountTransactionReport>
> = ({ navigation, route }) => {
  const { onLayout, creditLineId } = route.params;
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  const { useModalProps, closeModal } = useModalView({});
  if (layout.isMobile) {
    return <DownloadCardAccountTransactionReportNativeScreen onClose={onGoBack} onLayout={onLayout} creditLineId={creditLineId} />;
  }

  return <DownloadCardAccountTransactionReportWebScreen onClose={closeModal} onLayout={onLayout} creditLineId={creditLineId} />;
};
